import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IOwnerFormMeta {
    title: FormInputMeta;
    firstName: FormInputMeta;
    surname: FormInputMeta;
    lastName: FormInputMeta;
    birthdate: FormInputMeta;
    birthplace: FormInputMeta;
    firstIdentity: FormInputMeta;
    firstIdentityType: FormInputMeta;
    secondIdentity: FormInputMeta;
    secondIdentityType: FormInputMeta;
    gender: FormInputMeta;
    familyStatus: FormInputMeta;
    nationalitty: FormInputMeta;
    numberOfEmployees: FormInputMeta;
    
    schema: any;
  }

const OwnerFormMeta = {} as IOwnerFormMeta;

OwnerFormMeta.title = {
    name: "title",
    label: "Titre",
    type: "select",
    options:  [
        {
          label: 'Titre A',
          value: 'a'
        },
        {
          label: 'Titre B',
          value: 'b',
        },
        {
          label: 'Titre C',
          value: 'b',
        },
      ],
      validation: yup.string().required("Ce champ est requis"),
}
OwnerFormMeta.firstName = {
  name: 'firstName',
  type: 'text',
  label: 'Prenom',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
OwnerFormMeta.surname = {
  name: 'surname',
  type: 'text',
  label: 'Surnom',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
OwnerFormMeta.lastName = {
  name: 'lastName',
  type: 'text',
  label: 'Nom',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
OwnerFormMeta.birthdate = {
  name: 'birthdate',
  type: 'date',
  label: 'Date de naissance',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
OwnerFormMeta.birthplace = {
  name: 'birthplace',
  type: 'text',
  label: 'Lieu de naissance',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
OwnerFormMeta.firstIdentity = {
  name: 'firstIdentity',
  type: 'text',
  label: 'Première Identité',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
OwnerFormMeta.firstIdentityType = {
  name: 'firstIdentityType',
  label: "Type Première Identité",
  type: "select",
  options:  [
    {
      label: 'Type A',
      value: 'a'
    },
    {
      label: 'Type B',
      value: 'b',
    },
    {
      label: 'Type C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
OwnerFormMeta.secondIdentity = {
  name: 'secondIdentity',
  type: 'text',
  label: 'Seconde Identité',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
OwnerFormMeta.secondIdentityType = {
  name: 'secondIdentityType',
  label: "Type Seconde Identité",
  type: "select",
  options:  [
    {
      label: 'Type A',
      value: 'a'
    },
    {
      label: 'Type B',
      value: 'b',
    },
    {
      label: 'Type C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
OwnerFormMeta.gender = {
  name: 'gender',
  label: "Sexe",
  type: "select",
  options:  [
    {
      label: 'Homme',
      value: 'm'
    },
    {
      label: 'Femme',
      value: 'f',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
OwnerFormMeta.familyStatus = {
  name: 'familyStatus',
  label: "Situation familiale",
  type: "select",
  options:  [
    {
      label: 'Situation A',
      value: 'a'
    },
    {
      label: 'Situation B',
      value: 'b',
    },
    {
      label: 'Situation C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
OwnerFormMeta.nationalitty = {
  name: 'nationalitty',
  label: "Nationalité",
  type: "select",
  options:  [
    {
      label: 'Nationalité A',
      value: 'a'
    },
    {
      label: 'Nationalité B',
      value: 'b',
    },
    {
      label: 'Nationalité C',
      value: 'b',
    },
  ],
  validation: yup.string().required("Ce champ est requis"),
};
OwnerFormMeta.numberOfEmployees = {
  name: 'numberOfEmployees',
  type: 'number',
  label: 'Nombre d\'employés',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

OwnerFormMeta.schema = yup.object().shape(getValidationSchema(OwnerFormMeta));

export default OwnerFormMeta;